import React from 'react';
import { Accordion } from '@johnlewispartnership/wtr-ingredients/ingredients/Accordion';
import type { RecipeSummaryItem } from '../../../../api/definitions/recipes';
import styles from './index.scss';
import RecipeAccordionItem from './RecipeAccordionItem';

export interface RecipeAccordionProps {
  recipes: (RecipeSummaryItem | null)[];
}

const RecipesAccordion = ({ recipes }: RecipeAccordionProps) => {
  if (!recipes.length) return null;

  return (
    <Accordion
      scrollToItemWhenOpened
      theme="chevronRight"
      className={styles.recipesAccordion}
      data-testid="recipes-accordion"
    >
      {recipes.filter(Boolean).map(recipe => (
        <RecipeAccordionItem
          key={recipe.id}
          recipe={recipe}
          data-testid={`recipe-accordion-item-${recipe.id}`}
        />
      ))}
    </Accordion>
  );
};

export default RecipesAccordion;
